import React, { } from 'react';
import { Row, Col, message, Layout, Modal } from 'antd';
import TableWrapper from "../../elements/TableWrapper";
import MiCompAPI from '../../../util/api';
import AddMember from './AddMember';
const { Content } = Layout;
const { confirm } = Modal;
class Family extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [{
      title: 'Name',
      dataIndex: 'document_Name',
      width: '20%'
    },
    {
      title: 'Relation',
      dataIndex: 'isRequired',
      width: '20%',

    },
    {
      title: 'Email',
      dataIndex: 'approverSignatureIsRequired',
      width: '20%',

    },
    {
      title: 'Actions',
      width: '10%',
      render: (text, record) => {
        return (
          <div style={{ display: 'flex' }}>
            <>
              <i onClick={() => window.open(record["unq_FileName"], "_blank")} className="fa fa-eye fa-b" />
              <i className="fa fa-pencil fa-b" onClick={() => { this.UserDefaultHandler('edit', record["id"]) }} />

              <i onClick={() => this.showConfirm('delete', record["id"])} className="fa fa-trash fa-red " />
            </>
          </div>
        );
      }
    }];
    this.tableButtons = [];
    this.tableButtons.push({
      buttonType: "primary",
      content: "Add Member",
      clickHandler: () => {
        this.UserDefaultHandler("add", 0);
      },
    })

    this.state = {
      doc_types: [],
      doc_type: null,
      loading: false,
      roles: [],
      adddoc: false,
      doc_id: 0,
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  UserDefaultHandler = (key, id) => {

    switch (key) {
      case "add":
        this.setState({
          doc_id: id,
          adddoc: true,
          doc_type: null
        })
        break;
      case 'edit':
        this.api.invoke(
          "GetDocumentByID/" + id,
          "get",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {

                this.setState({
                  doc_type: data.data,
                  adddoc: true
                })
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            }
          },
          undefined
        );
        break;
      case 'delete':
        this.setState({ isLoading: true });
        this.api.invoke("DeleteDocumentByID/" + id, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.setState({ isLoading: false });
              this.GetDocuments();
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        });
        break
      default:
        break
    }
  }
  showConfirm = (type, id) => {
    confirm({
      title: "Do you want to delete this Compliance?",
      onOk: () => this.UserDefaultHandler(type, id),
      okText: "yes",
      cancelText: "No",
      onCancel() { },
    });
  }
  componentDidMount = () => {
    this.getClientMasters();
    this.GetDocuments();
  }
  GetDocuments = () => {
    this.setState({
      isLoading: true
    });
    this.api.invoke(
      "GetDocuments",
      "get",
      (data, success) => {
        if (success) {
          this.setState({
            doc_types: data.data,
            isLoading: false
          });
        }
      },
    );
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            roles: data.complianceRole
          });
        }
      },
      ["ComplianceRole"]
    );
  }
  UpsertDoc = (input, callback) => {
    this.api.invoke(
      "SaveandUpdateDocument",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.GetDocuments();
            this.adddocDefaultHandler();
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
        }
      },
      input
    );
  }
  adddocDefaultHandler = () => {
    this.setState({ adddoc: !this.state.adddoc });
  }
  render() {
    return (
      <Content>
        {(this.state.adddoc) ? <Modal
          visible={this.state.adddoc}
        > <AddMember roles={this.state.roles} userPermandMasters={this.props.userPermandMasters} closeDrawerHandler={this.adddocDefaultHandler} submitHandler={this.UpsertDoc} width="500" /></Modal> : null}

        <div className="mi_main_div" >
          <Row span={24} style={{ marginLeft: "8px" }}>
            <Col span={24}>
              <TableWrapper rowKey="id" title="Family"
                bordered={true} columns={this.columns} data={this.state.loading ? null : this.state.doc_types} buttons={this.tableButtons} loading={this.state.loading}
                search={true}
              />
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default Family;
